module.exports = __webpack_public_path__ + "img/mind_skeleton_16.006a6da1.png";